var modules_3fa78883 = {"container":"_r2ztrm","item":"_6nqqi2"};
import "../../../assets/BaHYf3N8.css";

export { modules_3fa78883 as default };
//# sourceMappingURL=Breadcrumb.module.less.js.map
